import { Button } from '@winnin/winnin_ui.components.button'
import { Modal } from '@winnin/winnin_ui.components.modal'
import { Title } from '@winnin/winnin_ui.components.title'

import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import { MODAL_STYLE } from './delete-file-dialog.consts'
import { translations } from './delete-file-dialog.i18n'
import type { DeleteFileDialogProps } from './delete-file-dialog.types'

import './delete-file-dialog.styles.scss'

export const DeleteFileDialog = ({ isOpen, onClose, onConfirm }: DeleteFileDialogProps) => {
  const t = useTranslate()

  return (
    <Modal isOpen={isOpen} style={MODAL_STYLE} onRequestClose={onClose} shouldCloseOnOverlayClick>
      <div className="DeleteFileDialog">
        <header className="DeleteFileDialog-header">
          <Title tag="h3" className="DeleteFileDialog-header-title">
            {t(translations.title)}
          </Title>
        </header>

        <p className="DeleteFileDialog-description">{t(translations.description)}</p>

        <footer className="DeleteFileDialog-footer">
          <Button onClick={onClose} appearance="link" variation="white">
            {t(TOLGEE_GLOBALS.cancel)}
          </Button>
          <Button onClick={onConfirm}>{t(TOLGEE_GLOBALS.exclude)}</Button>
        </footer>
      </div>
    </Modal>
  )
}
